/**
 * The names of the languages Alternis processes (`shared/utils/alternis/languages.ts`), as
 * alternis_voip names them (`client/public/locales/en.json` `lang.*`, dev @ 128cfc3). Keyed by
 * the language code, in that list's order. Looked up by code.
 */
export default {
	lang: {
		ar: "Arabic",
		cs: "Czech",
		da: "Danish",
		de: "German",
		el: "Greek",
		en: "English",
		es: "Spanish",
		fa: "Persian",
		fi: "Finnish",
		fr: "French",
		hu: "Hungarian",
		it: "Italian",
		lv: "Latvian",
		nl: "Dutch",
		no: "Norwegian",
		pl: "Polish",
		pt: "Portuguese",
		ro: "Romanian",
		ru: "Russian",
		sk: "Slovak",
		sl: "Slovenian",
		sv: "Swedish",
		tr: "Turkish",
		uk: "Ukrainian",
		vi: "Vietnamese",
		zh: "Chinese",
		az: "Azerbaijani",
		bg: "Bulgarian",
		bs: "Bosnian",
		et: "Estonian",
		hi: "Hindi",
		hr: "Croatian",
		id: "Indonesian",
		ja: "Japanese",
		ko: "Korean",
		lt: "Lithuanian",
		mk: "Macedonian",
		ms: "Malay",
		sr: "Serbian",
		ta: "Tamil",
		th: "Thai",
		ur: "Urdu",
	},
};
